import { render, staticRenderFns } from "./patientMyList.vue?vue&type=template&id=23b16a6f&scoped=true"
import script from "./patientMyList.vue?vue&type=script&lang=js"
export * from "./patientMyList.vue?vue&type=script&lang=js"
import style0 from "./patientMyList.vue?vue&type=style&index=0&id=23b16a6f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b16a6f",
  null
  
)

export default component.exports